import { motion } from "framer-motion";
import { ArrowRight, Sparkles } from "lucide-react";
import { Button } from "@/components/ui/button";

const TIMMA_URL = "https://bestill.timma.no/beautybykuleva";

// Category 1: Sminke og Hårstyling
const sminkeServices = [
  { name: "Brud Makeup", price: "3500,-" },
  { name: "Bryllupsoppseting", price: "3500,-" },
  { name: "Prøvetime til bryllup", price: "2200,-" },
  { name: "Oppsetting av hår", price: "fra 1390,-" },
  { name: "Krøller", price: "950,-" },
  { name: "Krøller Hollywood", price: "2390,-" },
  { name: "Dagsminke", price: "1100,-" },
  { name: "Fest Makeup", price: "1390,-" },
  { name: "Avreise til klienten", price: "fra 900,-" },
];

// Category 2: Permanent Makeup
const permanentServices = [
  { name: "Permanent Makeup: Lepper", price: "3500,-" },
  { name: "Powder Brows", price: "3500,-" },
  { name: "Permanent Makeup: Eyeliner", price: "Pris på forespørsel" },
  { name: "Powder Brows: Påfyll etter 30-40 dager", price: "1499,-" },
  { name: "Permanent Make Up: Påfyll lepper etter 30-40 dager", price: "1499,-" },
  { name: "Permanent Make Up: Påfyll eyeliner etter 30-60 dager", price: "999,-" },
  { name: "Fjerning av Permanent Makeup", price: "1500,-" },
];

// Category 3: Øyebryn og Vippeløft
const eyebrowServices = [
  { name: "Farging av vipper", price: "290,-" },
  { name: "Farge og forming av bryn", price: "550,-" },
  { name: "Farging av vipper og bryn, samt forming av bryn", price: "750,-" },
  { name: "Permanent vippeløft", price: "750,-" },
  { name: "Permanent vippeløft og farging av vipper", price: "890,-" },
  { name: "Brow Lift", price: "790,-" },
  { name: "Brow lift med farge", price: "950,-" },
  { name: "Forming av bryn", price: "399,-" },
  { name: "Brynstyling for menn", price: "499,-" },
];

// Category 4: Sugaring
const sugaringServices = [
  { name: "Sukkervoks: Brazilian (for kvinner)", price: "650,-" },
  { name: "Sukkervoks: Bikini", price: "490,-" },
  { name: "Sukkervoks: Legger", price: "550,-" },
  { name: "Sukkervoks: Armhule", price: "350,-" },
  { name: "Sukkervoks: Lår", price: "590,-" },
  { name: "Sukkervoks: Armer", price: "490,-" },
  { name: "Voksing av overleppe", price: "290,-" },
  { name: "Sukkervoks pakke (brasiliansk+armhuler+legger)", price: "1450,-" },
  { name: "Sukkervoks av legger og lår", price: "850,-" },
  { name: "Sukkervoks pakke (brasiliansk+armhuler+ben)", price: "fra 1690,-" },
  { name: "Sukkervoks: Ansikt", price: "Pris på forespørsel" },
  { name: "Sukkervoks av baken", price: "290,-" },
  { name: "Fjerning av nesehår", price: "290,-" },
];

function ServiceRow({ name, price, isLast }) {
  const isPriceOnRequest = price === "Pris på forespørsel";
  
  return (
    <div className={`flex items-center justify-between py-5 px-2 sm:px-4 ${!isLast ? 'border-b border-[#E8E8E8]' : ''}`}>
      <span className="text-[#1a1a1a] font-medium text-sm sm:text-base flex-1 pr-4">
        {name}
      </span>
      <div className="flex items-center gap-4 sm:gap-6 flex-shrink-0">
        <span className={`whitespace-nowrap ${
          isPriceOnRequest 
            ? "text-[#666666] text-xs sm:text-sm font-semibold" 
            : "text-[#1a1a1a] text-sm sm:text-base font-bold"
        }`}>
          {price}
        </span>
        <a
          href={TIMMA_URL}
          target="_blank"
          rel="noopener noreferrer"
          className="px-4 py-2 sm:px-5 sm:py-2.5 text-xs sm:text-sm font-semibold text-[#1a1a1a] border-2 border-[#1a1a1a] rounded-full hover:bg-[#1a1a1a] hover:text-white transition-all duration-200 whitespace-nowrap"
        >
          Bestill
        </a>
      </div>
    </div>
  );
}

function CategoryBlock({ title, iconElement, services, categoryId }) {
  return (
    <motion.div
      initial={{ opacity: 0, y: 30 }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true }}
      transition={{ duration: 0.5 }}
      className="mb-12"
      id={categoryId}
      data-testid={`category-${categoryId}`}
    >
      <div className="bg-white rounded-3xl shadow-lg shadow-[#D4A5A5]/10 overflow-hidden border border-[#F9F5F6]">
        <div className="bg-gradient-to-r from-[#FBF8F8] to-[#F9F5F6] px-6 sm:px-8 py-6 sm:py-8">
          <div className="flex flex-col sm:flex-row sm:items-center sm:justify-between gap-4">
            <div className="flex items-center gap-4">
              <div className="w-14 h-14 sm:w-16 sm:h-16 rounded-2xl bg-white shadow-md flex items-center justify-center text-[#D4A5A5]">
                {iconElement}
              </div>
              <h2 className="font-['Playfair_Display'] text-2xl sm:text-3xl lg:text-4xl font-bold text-[#4A4A4A] tracking-tight">
                {title}
              </h2>
            </div>
            <a
              href={TIMMA_URL}
              target="_blank"
              rel="noopener noreferrer"
              data-testid={`category-book-${categoryId}`}
            >
              <Button className="btn-primary rounded-full px-6 sm:px-8 py-2.5 text-sm shadow-md hover:shadow-lg transition-shadow">
                Bestill time
                <ArrowRight size={16} className="ml-2" />
              </Button>
            </a>
          </div>
        </div>

        <div className="px-4 sm:px-6 py-4">
          {services.map((service, idx) => (
            <ServiceRow 
              key={idx} 
              name={service.name} 
              price={service.price} 
              isLast={idx === services.length - 1}
            />
          ))}
        </div>
      </div>
    </motion.div>
  );
}

export default function ServicesPage() {
  return (
    <div className="pt-20 bg-[#FDFBFB]">
      {/* Hero Section */}
      <section className="relative py-16 sm:py-24 bg-gradient-to-b from-[#F9F5F6] to-[#FDFBFB]">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            className="text-center max-w-3xl mx-auto"
          >
            <span className="inline-flex items-center gap-2 px-4 py-2 rounded-full bg-white/80 text-[#D4A5A5] text-sm font-medium mb-6 shadow-sm">
              <Sparkles size={16} />
              Våre tjenester
            </span>
            <h1 className="font-['Playfair_Display'] text-4xl sm:text-5xl lg:text-6xl font-bold text-[#4A4A4A] mb-6">
              Tjenester &{" "}
              <span className="italic text-[#D4A5A5]">Priser</span>
            </h1>
            <p className="text-[#8C8C8C] text-base sm:text-lg max-w-2xl mx-auto leading-relaxed">
              Utforsk vårt komplette utvalg av skjønnhetsbehandlinger. 
              Fra brudesminke til permanent makeup – vi har noe for alle anledninger.
            </p>
          </motion.div>
        </div>
      </section>

      {/* Quick Navigation */}
      <section className="sticky top-20 z-40 bg-white/95 backdrop-blur-md border-b border-[#F2E8E8] shadow-sm">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="flex items-center gap-2 sm:gap-3 py-4 overflow-x-auto scrollbar-hide">
            <a
              href="#sminke-har"
              className="px-4 py-2.5 rounded-full text-xs sm:text-sm font-medium whitespace-nowrap bg-[#F9F5F6] text-[#4A4A4A] hover:bg-[#D4A5A5] hover:text-white transition-all duration-300"
            >
              Sminke og Hårstyling
            </a>
            <a
              href="#permanent-makeup"
              className="px-4 py-2.5 rounded-full text-xs sm:text-sm font-medium whitespace-nowrap bg-[#F9F5F6] text-[#4A4A4A] hover:bg-[#D4A5A5] hover:text-white transition-all duration-300"
            >
              Permanent Makeup
            </a>
            <a
              href="#oyebryn-vippeloft"
              className="px-4 py-2.5 rounded-full text-xs sm:text-sm font-medium whitespace-nowrap bg-[#F9F5F6] text-[#4A4A4A] hover:bg-[#D4A5A5] hover:text-white transition-all duration-300"
            >
              Øyebryn og Vippeløft
            </a>
            <a
              href="#sugaring"
              className="px-4 py-2.5 rounded-full text-xs sm:text-sm font-medium whitespace-nowrap bg-[#F9F5F6] text-[#4A4A4A] hover:bg-[#D4A5A5] hover:text-white transition-all duration-300"
            >
              Sugaring
            </a>
          </div>
        </div>
      </section>

      {/* Services Categories */}
      <section className="py-12 sm:py-16">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
          
          <CategoryBlock 
            title="Sminke og Hårstyling" 
            iconElement={
              <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" className="w-7 h-7">
                <path d="M9 3v2m6-2v2M9 19c-3 0-6-2-6-6 0-3 2-5 4-6l1-4h8l1 4c2 1 4 3 4 6 0 4-3 6-6 6" />
                <path d="M9 19v2a1 1 0 001 1h4a1 1 0 001-1v-2" />
                <circle cx="12" cy="13" r="2" />
              </svg>
            }
            services={sminkeServices}
            categoryId="sminke-har" 
          />

          <CategoryBlock 
            title="Permanent Makeup" 
            iconElement={
              <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" className="w-7 h-7">
                <path d="M2 12c0-3 4-7 10-7s10 4 10 7" />
                <path d="M12 5c-2 0-4 1-5 3" />
                <ellipse cx="12" cy="14" rx="3" ry="2" />
                <circle cx="12" cy="14" r="1" fill="currentColor" />
              </svg>
            }
            services={permanentServices}
            categoryId="permanent-makeup" 
          />

          <CategoryBlock 
            title="Øyebryn og Vippeløft" 
            iconElement={
              <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" className="w-7 h-7">
                <path d="M2 12c2-4 6-6 10-6s8 2 10 6" />
                <path d="M4 10l-1-3M7 8l-1-3M12 7V3M17 8l1-3M20 10l1-3" />
                <ellipse cx="12" cy="13" rx="4" ry="2.5" />
              </svg>
            }
            services={eyebrowServices}
            categoryId="oyebryn-vippeloft" 
          />

          <CategoryBlock 
            title="Sugaring" 
            iconElement={
              <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" className="w-7 h-7">
                <path d="M12 22c-4-2-8-6-8-12C4 6 8 2 12 2c6 0 8 4 8 8 0 6-4 10-8 12z" />
                <path d="M12 22V12" />
                <path d="M12 12c-2-2-4-3-4-5" />
                <path d="M12 15c2-1 3-2 4-4" />
              </svg>
            }
            services={sugaringServices}
            categoryId="sugaring" 
          />

        </div>
      </section>

      {/* CTA Section */}
      <section className="py-16 sm:py-20 bg-gradient-to-t from-[#F9F5F6] to-[#FDFBFB]">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
          >
            <h2 className="font-['Playfair_Display'] text-2xl sm:text-3xl lg:text-4xl font-bold text-[#4A4A4A] mb-4">
              Klar til å bestille?
            </h2>
            <p className="text-[#8C8C8C] mb-8 max-w-xl mx-auto leading-relaxed">
              Book din time enkelt og raskt via vårt online bookingsystem. 
              Vi gleder oss til å se deg!
            </p>
            <a
              href={TIMMA_URL}
              target="_blank"
              rel="noopener noreferrer"
              data-testid="services-cta-book"
            >
              <Button className="btn-primary rounded-full px-10 py-6 text-base shadow-lg hover:shadow-xl transition-shadow">
                Bestill time nå
                <ArrowRight size={18} className="ml-2" />
              </Button>
            </a>
          </motion.div>
        </div>
      </section>
    </div>
  );
}
